import React, { useContext, useState, useEffect } from 'react';
import { Tooltip } from 'antd';
import ValueContext from './Context';

export default function VersionDropdown() {
  const { version, changeVersion, quadro, getText, locale } = useContext(ValueContext);
  const [showTip, setshowTip] = useState(false);
  const [text, settext] = useState(getText());

  function handleVersionChange(e) {
    if (e.target.value === '3.2') {
      changeVersion('3.2');
    } else if (e.target.value === '4.0') {
      changeVersion('4.0');
    } else {
      changeVersion('4.1');
    }
  }

  useEffect(() => {
    settext(getText());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  return (
    <>
      <Tooltip title={text.Menu.VersionToolTip} visible={showTip}>
        <span
          className={quadro ? 'RadioButtonVersion1 RadioDisable' : 'RadioButtonVersion1'}
          onMouseEnter={() => {
            if (quadro) setshowTip(true);
          }}
          onMouseLeave={() => setshowTip(false)}>
          <input
            type='radio'
            id='versionChoice3'
            name='version'
            value='3.2'
            checked={version === '3.2'}
            onChange={handleVersionChange}
            disabled={quadro}
          />
          <label className='RadioLabel' htmlFor='versionChoice3'>
            Version 3.2
          </label>
        </span>
      </Tooltip>
      <span className='RadioButtonVersion2'>
        <input
          type='radio'
          id='versionChoice2'
          name='version'
          value='4.0'
          checked={version === '4.0'}
          onChange={handleVersionChange}
        />
        <label className='RadioLabel' htmlFor='versionChoice2'>
          Version 4.0
        </label>
      </span>

      <span className='RadioButtonVersion3'>
        <input
          type='radio'
          id='versionChoice1'
          name='version'
          value='4.1'
          checked={version === '4.1'}
          onChange={handleVersionChange}
        />
        <label className='RadioLabel' htmlFor='versionChoice1'>
          Version 4.1
        </label>
      </span>
    </>
  );
}
